"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Context {
    constructor(registry) {
        this.getComponents = (contexts) => {
            const components = contexts.map((context) => context.keys().map(context)).flat();
            return components;
        };
        this.registerComponents = (contexts) => {
            const components = this.getComponents(contexts);
            components.forEach((module) => {
                const component = module.default;
                if (!component.component) {
                    console.error(`Invalid component configuration: ${component}`);
                    return;
                }
                this.registry.register(component.component, component.async).as(component.name);
            });
        };
        this.registry = registry;
    }
}
exports.default = Context;
